import { render } from "./intangibleOfflineInfo.vue?vue&type=template&id=3455b80f&scoped=true"
import script from "./intangibleOfflineInfo.vue?vue&type=script&lang=js"
export * from "./intangibleOfflineInfo.vue?vue&type=script&lang=js"

import "./intangibleOfflineInfo.vue?vue&type=style&index=0&id=3455b80f&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3455b80f"]])

export default __exports__